import React from 'react';
import { connect } from 'react-redux';
import Croppie from 'croppie';
import { mediaPickerActions } from '../store';

export const CropperImageIdentifier = 'cropper-image-element';
export var ImageCropperInstance = null;

class ImageCropper extends React.Component {
    render() {
        return (
            <img 
                id={CropperImageIdentifier} 
                hidden
                alt='Crop settings'
            />
        );
    }

    componentDidMount = () => {
        const { imageCropperData } = this.props;
        if (imageCropperData) {
            this.createCropperControl();
        }
    }

    componentDidUpdate = (prevProps) => {
        const { imageCropperData: oldCropperData } = prevProps;
        const { imageCropperData: newCropperData } = this.props;

        if (newCropperData !== oldCropperData) {
            if (newCropperData)
                this.createCropperControl();
            else
                this.destroyCropperControl();
        }
    }

    componentWillUnmount = () => {
        this.destroyCropperControl();
    }

    createCropperControl = () => {
        const { imageCropperData, cropperConfiguration } = this.props;

        if (ImageCropperInstance == null && imageCropperData) {
            ImageCropperInstance = new Croppie(document.getElementById(CropperImageIdentifier), {
                viewport: {
                    width: cropperConfiguration.VIEWPORT_WIDTH,
                    height: cropperConfiguration.VIEWPORT_HEIGHT,
                    type: cropperConfiguration.SHAPE
                },
                boundary: {
                    width: cropperConfiguration.BOUNDARY_WIDTH,
                    height: cropperConfiguration.BOUNDARY_HEIGHT
                },
                enableResize: cropperConfiguration.ENABLE_RESIZE !== undefined 
                    ? cropperConfiguration.ENABLE_RESIZE 
                    : cropperConfiguration.SHAPE === 'square',
            });

            ImageCropperInstance.bind({
                url: imageCropperData.data,
                zoom: 0
            }).then(function () {
                // Can be added some code to set a flag
            });
        }
    }

    destroyCropperControl = () => {
        if (ImageCropperInstance)
            ImageCropperInstance.destroy();

        ImageCropperInstance = null;
    }
}

const mapStateToProps = (state) => {
    const { imageCropperData } = state.mediaPicker;
    return { imageCropperData };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    return { setProperty }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageCropper);